export default __webpack_public_path__ + "static/media/manage_order.65cf4857.png";